var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsV3Event from '@wix/ambassador-events-v3-event/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var LocationType;
(function (LocationType) {
    /** Default value. This value is unused. */
    LocationType["UNKNOWN_LOCATION"] = "UNKNOWN_LOCATION";
    LocationType["VENUE"] = "VENUE";
    LocationType["ONLINE"] = "ONLINE";
})(LocationType || (LocationType = {}));
export var SubdivisionSubdivisionType;
(function (SubdivisionSubdivisionType) {
    SubdivisionSubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionSubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionSubdivisionType || (SubdivisionSubdivisionType = {}));
export var RecurrenceStatusStatus;
(function (RecurrenceStatusStatus) {
    /** Default value. This value is unused. */
    RecurrenceStatusStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Event happens only once. */
    RecurrenceStatusStatus["ONE_TIME"] = "ONE_TIME";
    /** Event is repeating and has a list of scheduled repetitions. */
    RecurrenceStatusStatus["RECURRING"] = "RECURRING";
    /** An upcoming event from the list of repetitions. */
    RecurrenceStatusStatus["RECURRING_UPCOMING"] = "RECURRING_UPCOMING";
    /** Latest ended event from the list of repetitions. */
    RecurrenceStatusStatus["RECURRING_RECENTLY_ENDED"] = "RECURRING_RECENTLY_ENDED";
    /** Latest cancelled event from the list of repetitions. */
    RecurrenceStatusStatus["RECURRING_RECENTLY_CANCELED"] = "RECURRING_RECENTLY_CANCELED";
})(RecurrenceStatusStatus || (RecurrenceStatusStatus = {}));
export var Status;
(function (Status) {
    /** Default value. This value is unused */
    Status["UNKNOWN_EVENT_STATUS"] = "UNKNOWN_EVENT_STATUS";
    /** Event is public and scheduled to start */
    Status["UPCOMING"] = "UPCOMING";
    /** Event has started */
    Status["STARTED"] = "STARTED";
    /** Event has ended */
    Status["ENDED"] = "ENDED";
    /** Event is canceled */
    Status["CANCELED"] = "CANCELED";
    /** Event is not public */
    Status["DRAFT"] = "DRAFT";
})(Status || (Status = {}));
export var RegistrationTypeType;
(function (RegistrationTypeType) {
    /** Default value. This value is unused */
    RegistrationTypeType["UNKNOWN_REGISTRATION_TYPE"] = "UNKNOWN_REGISTRATION_TYPE";
    /** Registration via RSVP */
    RegistrationTypeType["RSVP"] = "RSVP";
    /** Registration via ticket purchase */
    RegistrationTypeType["TICKETING"] = "TICKETING";
    /** External registration */
    RegistrationTypeType["EXTERNAL"] = "EXTERNAL";
    /** Registration not available */
    RegistrationTypeType["NONE"] = "NONE";
})(RegistrationTypeType || (RegistrationTypeType = {}));
export var RegistrationStatusStatus;
(function (RegistrationStatusStatus) {
    /** Registration status is not applicable */
    RegistrationStatusStatus["UNKNOWN_REGISTRATION_STATUS"] = "UNKNOWN_REGISTRATION_STATUS";
    /** Registration to event is closed */
    RegistrationStatusStatus["CLOSED_AUTOMATICALLY"] = "CLOSED_AUTOMATICALLY";
    /** Registration to event is closed manually */
    RegistrationStatusStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    /** Registration is open via RSVP */
    RegistrationStatusStatus["OPEN_RSVP"] = "OPEN_RSVP";
    /** Registration to event waitlist is open via RSVP */
    RegistrationStatusStatus["OPEN_RSVP_WAITLIST_ONLY"] = "OPEN_RSVP_WAITLIST_ONLY";
    /** Registration is open via ticket purchase */
    RegistrationStatusStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    /** Registration is open via external URL */
    RegistrationStatusStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    /** Registration will be open via RSVP */
    RegistrationStatusStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
})(RegistrationStatusStatus || (RegistrationStatusStatus = {}));
export var ResponseType;
(function (ResponseType) {
    /** Default value. This value is unused. */
    ResponseType["UNKNOWN_RESPONSE_TYPE"] = "UNKNOWN_RESPONSE_TYPE";
    /** Only a **Yes** answer is available for the registration. */
    ResponseType["YES_ONLY"] = "YES_ONLY";
    /** *Yes** and **No** answers are available for the registration. */
    ResponseType["YES_AND_NO"] = "YES_AND_NO";
})(ResponseType || (ResponseType = {}));
export var TaxType;
(function (TaxType) {
    /** Default value. This value is unused. */
    TaxType["UNKNOWN_TAX_TYPE"] = "UNKNOWN_TAX_TYPE";
    /** Tax is included in the ticket price */
    TaxType["INCLUDED_IN_PRICE"] = "INCLUDED_IN_PRICE";
    /** Tax is added to the final total at the checkout */
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var GuestTypeType;
(function (GuestTypeType) {
    /** Default value. This value is unused */
    GuestTypeType["UNKNOWN_GUEST_TYPE"] = "UNKNOWN_GUEST_TYPE";
    /** Site visitor or member */
    GuestTypeType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
    /** Site member */
    GuestTypeType["MEMBER"] = "MEMBER";
})(GuestTypeType || (GuestTypeType = {}));
export var InitialRegistrationTypeType;
(function (InitialRegistrationTypeType) {
    /** Default value. This value is unused */
    InitialRegistrationTypeType["UNKNOWN_INITIAL_REGISTRATION_TYPE"] = "UNKNOWN_INITIAL_REGISTRATION_TYPE";
    /** Registration via RSVP */
    InitialRegistrationTypeType["RSVP"] = "RSVP";
    /** Registration via ticket purchase */
    InitialRegistrationTypeType["TICKETING"] = "TICKETING";
})(InitialRegistrationTypeType || (InitialRegistrationTypeType = {}));
export var InputControlType;
(function (InputControlType) {
    /** Single text value field. */
    InputControlType["INPUT"] = "INPUT";
    /** Single text value field. */
    InputControlType["TEXTAREA"] = "TEXTAREA";
    /** Single-choice field of predefined values. */
    InputControlType["DROPDOWN"] = "DROPDOWN";
    /** Single-choice field of predefined values. */
    InputControlType["RADIO"] = "RADIO";
    /** Multiple-choice field of predefined values. */
    InputControlType["CHECKBOX"] = "CHECKBOX";
    /** First and last name fields. */
    InputControlType["NAME"] = "NAME";
    /** Additional guests and respective guest names fields. */
    InputControlType["GUEST_CONTROL"] = "GUEST_CONTROL";
    /** Single-line address field. */
    InputControlType["ADDRESS_SHORT"] = "ADDRESS_SHORT";
    /** Full address field. */
    InputControlType["ADDRESS_FULL"] = "ADDRESS_FULL";
    /** Year, month and day fields. */
    InputControlType["DATE"] = "DATE";
})(InputControlType || (InputControlType = {}));
export var ValueType;
(function (ValueType) {
    ValueType["TEXT"] = "TEXT";
    ValueType["NUMBER"] = "NUMBER";
    ValueType["TEXT_ARRAY"] = "TEXT_ARRAY";
    ValueType["DATE_TIME"] = "DATE_TIME";
    ValueType["ADDRESS"] = "ADDRESS";
})(ValueType || (ValueType = {}));
export var ConferenceTypeType;
(function (ConferenceTypeType) {
    /** Default value. This value is unused */
    ConferenceTypeType["UNKNOWN_CONFERENCE_TYPE"] = "UNKNOWN_CONFERENCE_TYPE";
    /** Guests can publish and subscribe to video and audio. */
    ConferenceTypeType["MEETING"] = "MEETING";
    /** Guests can only subscribe to video and audio. */
    ConferenceTypeType["WEBINAR"] = "WEBINAR";
})(ConferenceTypeType || (ConferenceTypeType = {}));
export var Type;
(function (Type) {
    /** Created manually by the user. */
    Type["MANUAL"] = "MANUAL";
    /** Created automatically when publishing recurring events. */
    Type["RECURRING_EVENT"] = "RECURRING_EVENT";
    /** Created automatically and used to store component events. */
    Type["COMPONENT"] = "COMPONENT";
})(Type || (Type = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Include `description`, `mainImage` and `calendarLinks` in the response. */
    RequestedFields["DETAILS"] = "DETAILS";
    /** Include `about` event rich text in the response. */
    RequestedFields["TEXTS"] = "TEXTS";
    /** Include `registration` in the response. */
    RequestedFields["REGISTRATION"] = "REGISTRATION";
    /** Include `eventPageUrl` in the response. */
    RequestedFields["URLS"] = "URLS";
    /** Include `form` in the response. */
    RequestedFields["FORM"] = "FORM";
    /** Include `dashboard` in the response. */
    RequestedFields["DASHBOARD"] = "DASHBOARD";
    /** Include `feed` in the response. */
    RequestedFields["FEED"] = "FEED";
    /** Include `onlineConferencing` in the response. */
    RequestedFields["ONLINE_CONFERENCING_SESSION"] = "ONLINE_CONFERENCING_SESSION";
    /** Include `seoSettings` in the response. */
    RequestedFields["SEO_SETTINGS"] = "SEO_SETTINGS";
    /** Include `agendaSettings` in the response. */
    RequestedFields["AGENDA"] = "AGENDA";
    /** Include `categories` in the response. */
    RequestedFields["CATEGORIES"] = "CATEGORIES";
    RequestedFields["CUSTOMIZABLE_TICKETS"] = "CUSTOMIZABLE_TICKETS";
})(RequestedFields || (RequestedFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var CommonSortOrder;
(function (CommonSortOrder) {
    CommonSortOrder["ASC"] = "ASC";
    CommonSortOrder["DESC"] = "DESC";
})(CommonSortOrder || (CommonSortOrder = {}));
export var Relation;
(function (Relation) {
    /**
     * User is attending the event.
     * User has RSVP with status YES or has ordered tickets.
     */
    Relation["ATTENDING"] = "ATTENDING";
})(Relation || (Relation = {}));
export var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["VENUE"] = "VENUE";
    LocationLocationType["ONLINE"] = "ONLINE";
})(LocationLocationType || (LocationLocationType = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var EventsRecurrenceStatusStatus;
(function (EventsRecurrenceStatusStatus) {
    /** Event occurs only once. */
    EventsRecurrenceStatusStatus["ONE_TIME"] = "ONE_TIME";
    /** Event is recurring. */
    EventsRecurrenceStatusStatus["RECURRING"] = "RECURRING";
    /** Marks the next upcoming occurrence of the recurring event. */
    EventsRecurrenceStatusStatus["RECURRING_NEXT"] = "RECURRING_NEXT";
    /** Marks the most recent ended occurrence of the recurring event. */
    EventsRecurrenceStatusStatus["RECURRING_LAST_ENDED"] = "RECURRING_LAST_ENDED";
    /** Marks the most recent canceled occurrence of the recurring event. */
    EventsRecurrenceStatusStatus["RECURRING_LAST_CANCELED"] = "RECURRING_LAST_CANCELED";
})(EventsRecurrenceStatusStatus || (EventsRecurrenceStatusStatus = {}));
export var EventStatus;
(function (EventStatus) {
    /** Event is public and scheduled to start */
    EventStatus["SCHEDULED"] = "SCHEDULED";
    /** Event has started */
    EventStatus["STARTED"] = "STARTED";
    /** Event has ended */
    EventStatus["ENDED"] = "ENDED";
    /** Event was canceled */
    EventStatus["CANCELED"] = "CANCELED";
    /** Event is not public and needs to be published */
    EventStatus["DRAFT"] = "DRAFT";
})(EventStatus || (EventStatus = {}));
export var EventType;
(function (EventType) {
    /** Type not available for this request fieldset */
    EventType["NA_EVENT_TYPE"] = "NA_EVENT_TYPE";
    /** Registration via RSVP */
    EventType["RSVP"] = "RSVP";
    /** Registration via ticket purchase */
    EventType["TICKETS"] = "TICKETS";
    /** External registration */
    EventType["EXTERNAL"] = "EXTERNAL";
    /** Registration not available */
    EventType["NO_REGISTRATION"] = "NO_REGISTRATION";
})(EventType || (EventType = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    /** Registration status is not applicable */
    RegistrationStatus["NA_REGISTRATION_STATUS"] = "NA_REGISTRATION_STATUS";
    /** Registration to event is closed */
    RegistrationStatus["CLOSED"] = "CLOSED";
    /** Registration to event is closed manually */
    RegistrationStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    /** Registration is open via RSVP */
    RegistrationStatus["OPEN_RSVP"] = "OPEN_RSVP";
    /** Registration to event waitlist is open via RSVP */
    RegistrationStatus["OPEN_RSVP_WAITLIST"] = "OPEN_RSVP_WAITLIST";
    /** Registration is open via ticket purchase */
    RegistrationStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    /** Registration is open via external URL */
    RegistrationStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    /** Registration will be open via RSVP */
    RegistrationStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
})(RegistrationStatus || (RegistrationStatus = {}));
export var RsvpStatusOptions;
(function (RsvpStatusOptions) {
    /** Only YES RSVP status is available for RSVP registration */
    RsvpStatusOptions["YES_ONLY"] = "YES_ONLY";
    /** YES and NO RSVP status options are available for the registration */
    RsvpStatusOptions["YES_AND_NO"] = "YES_AND_NO";
})(RsvpStatusOptions || (RsvpStatusOptions = {}));
export var EventsTaxType;
(function (EventsTaxType) {
    /** Tax is included in the ticket price */
    EventsTaxType["INCLUDED"] = "INCLUDED";
    /** Tax is added to the order at the checkout */
    EventsTaxType["ADDED"] = "ADDED";
    /** Tax is added to the final total at the checkout */
    EventsTaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(EventsTaxType || (EventsTaxType = {}));
export var VisitorType;
(function (VisitorType) {
    /** Site visitor (including member) */
    VisitorType["VISITOR"] = "VISITOR";
    /** Site member */
    VisitorType["MEMBER"] = "MEMBER";
    /** Site visitor or member */
    VisitorType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
})(VisitorType || (VisitorType = {}));
export var ConferenceType;
(function (ConferenceType) {
    /** Everyone in the meeting can publish and subscribe video and audio. */
    ConferenceType["MEETING"] = "MEETING";
    /** Guests can only subscribe to video and audio. */
    ConferenceType["WEBINAR"] = "WEBINAR";
})(ConferenceType || (ConferenceType = {}));
export var State;
(function (State) {
    /** Created manually by the user. */
    State["MANUAL"] = "MANUAL";
    /** Created automatically. */
    State["AUTO"] = "AUTO";
    /** Created when publishing recurring events. */
    State["RECURRING_EVENT"] = "RECURRING_EVENT";
    /** Category is hidden. */
    State["HIDDEN"] = "HIDDEN";
    /** Category is used to store component events. */
    State["COMPONENT"] = "COMPONENT";
})(State || (State = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _agendaSettings = { pageUrl: 'wix.common.PageUrl' };
const _bulkCancelEventsByFilterRequest = {};
const _bulkCancelEventsByFilterResponse = {};
const _bulkDeleteEventsByFilterRequest = {};
const _bulkDeleteEventsByFilterResponse = {};
const _cancelEventRequest = {};
const _cancelEventResponse = { event: '_v3Event' };
const _cloneEventRequest = { event: '_v3Event' };
const _cloneEventResponse = { event: '_v3Event' };
const _countEventsByStatusRequest = {};
const _countEventsByStatusResponse = {};
const _createEventRequest = { event: '_v3Event' };
const _createEventResponse = { event: '_v3Event' };
const _deleteEventRequest = {};
const _deleteEventResponse = {};
const _findEventRequest = {};
const _findEventResponse = { event: '_v3Event' };
const _getEventBySlugRequest = {};
const _getEventBySlugResponse = { event: '_v3Event' };
const _getEventRequest = {};
const _getEventResponse = { event: '_v3Event' };
const _listEventsByCategoryRequest = {};
const _listEventsByCategoryResponse = { events: '_v3Event' };
const _location = { address: 'wix.common.Address' };
const _publishDraftEventRequest = {};
const _publishDraftEventResponse = { event: '_v3Event' };
const _queryEventsRequest = {};
const _queryEventsResponse = { events: '_v3Event' };
const _updateEventRequest = { event: '_v3Event' };
const _updateEventResponse = { event: '_v3Event' };
const _v3Event = {
    mainImage: 'wix.common.Image',
    eventPageUrl: 'wix.common.PageUrl',
    location: '_location',
    agendaSettings: '_agendaSettings',
};
/**
 * Creates an event.
 *
 *
 * The event includes a default registration form in the selected language, which consists of input fields for first name, last name, and email. See [Registration Form](https://www.wix.com/velo/reference/wix-events-v2/forms/introduction) for more information.
 *
 * You can create the event as a draft by setting the draft value to true. Otherwise, the event is published right away.
 *
 * The event is automatically set up to send daily summary reports of new guests to your business email.
 * @param event - Event data.
 * @public
 * @requiredField event
 * @requiredField event.dateAndTimeSettings
 * @requiredField event.location
 * @requiredField event.registration.initialType
 * @requiredField event.title
 * @param options - Optional fields.
 * @adminMethod
 * @returns Created event.
 */
export function createEvent(event, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            event: '$[0]',
            draft: '$[1].draft',
            fields: '$[1].fields',
        };
        const responseTransformation = '$.event';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createEventRequest,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createEventResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([event, options]);
        const reqOpts = ambassadorWixEventsV3Event.createEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'event',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Clones an event, including the registration form, notifications, multilingual translations and ticket configuration from the original event.
 *
 *
 * The new event's date is automatically set to 14 days from the original event date.
 * If an event with the same title already exists, the new event's title gets a sequence number. For example, if you clone an event named "Leather Crafting 101", the new event's title is "Leather Crafting 101 (1)".  You can change the required entity field values while cloning an event.
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @param options - Optional fields.
 * @adminMethod
 */
export function cloneEvent(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            event: '$[1].event',
            fieldmask: '$[1].fieldmask',
            draft: '$[1].draft',
            fields: '$[1].fields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cloneEventRequest,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cloneEventResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV3Event.cloneEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates an event.
 * @param _id - Event ID.
 * @public
 * @requiredField _id
 * @param options - Optional fields.
 * @adminMethod
 * @returns Updated event.
 */
export function updateEvent(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            event: { '*': '$[1].event', id: '$[0]' },
            fieldmask: '$[1].fieldmask',
            fields: '$[1].fields',
        };
        const responseTransformation = '$.event';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateEventRequest,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateEventResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixEventsV3Event.updateEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Publishes a draft event to your live site. Once published, the event's status changes from `DRAFT` to `UPCOMING.`
 *
 *
 * It's impossible to revert the `DRAFT` status after publishing. The only option is to clone the event, and then delete the original one.
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @param options - Optional fields.
 * @adminMethod
 */
export function publishDraftEvent(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0]', fields: '$[1].fields' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _publishDraftEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _publishDraftEventResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV3Event.publishDraftEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Cancels an event.
 *
 *
 * After cancellation, registration for an event is closed. To reuse the event, [clone](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/cloneevent) and [publish](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/publishdraftevent) it again.
 * If event cancellation notifications are enabled, canceling an event automatically triggers the sending of cancellation emails and/or push notifications to registered guests.
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @param options - Optional fields.
 * @adminMethod
 */
export function cancelEvent(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0]', fields: '$[1].fields' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cancelEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cancelEventResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV3Event.cancelEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Cancels multiple events that meet the given criteria.
 *
 *
 * After cancellation, registration for an event is closed. To reuse the event, [clone](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/cloneevent) and [publish](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/publishdraftevent) it again.
 * If event cancellation notifications are enabled, canceling an event automatically triggers the sending of cancellation emails and/or push notifications to registered guests.
 * @public
 * @requiredField options.filter.filter
 * @param options - Optional fields.
 * @adminMethod
 */
export function bulkCancelEventsByFilter(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0].filter' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkCancelEventsByFilterRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkCancelEventsByFilterResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV3Event.bulkCancelEventsByFilter(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Permanently deletes an event. <br> <br>
 * You can retrieve the deleted event through a GDPR access request.
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @adminMethod
 */
export function deleteEvent(eventId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId]);
        const reqOpts = ambassadorWixEventsV3Event.deleteEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Permanently deletes multiple events that meet the given criteria.
 *
 *
 * You can retrieve the deleted events through a GDPR access request.
 * @public
 * @requiredField options.filter.filter
 * @param options - Optional fields.
 * @adminMethod
 */
export function bulkDeleteEventsByFilter(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0].filter' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkDeleteEventsByFilterRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkDeleteEventsByFilterResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV3Event.bulkDeleteEventsByFilter(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a query to retrieve a list of events.
 *
 *
 * The `queryEvents()` function builds a query to retrieve a list of events and returns a [`EventsQueryBuilder`](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/eventsquerybuilder) object.
 *
 * The returned object contains the query definition, which is typically used to run the query using the [`find()`](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/eventsquerybuilder/find) function.
 *
 * You can refine the query by chaining `EventsQueryBuilder` functions onto the query. `EventsQueryBuilder` functions enable you to sort, filter, and control the results `queryEvents()` returns.
 *
 * `queryEvents()` runs with these `EventsQueryBuilder` defaults, which you can override:
 *
 * - [`skip(0)`](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/eventsquerybuilder/skip)
 * - [`limit(50)`](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/eventsquerybuilder/limit)
 * - [`descending("_createdDate")`](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/eventsquerybuilder/descending)
 *
 * The functions that are chained to `queryEvents()` are applied in the order they're called. For example, if you apply `ascending('title')` and then `descending('status')`, the results are sorted first by the `title`, and then, if there are multiple results with the same `title`, the items are sorted by `status`.
 * @public
 * @param options - Optional fields.
 * @permissionId WIX_EVENTS.READ_EVENTS
 */
export function queryEvents(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.events',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryEventsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryEventsResponse,
        depSchemas: { _agendaSettings, _location, _v3Event },
        fqdnTransformation: {
            paths: [...['Array#events']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixEventsV3Event.queryEvents(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'OFFSET',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Counts events by status.
 * @public
 * @param options - Optional fields.
 */
export function countEventsByStatus(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            filter: '$[0].filter',
            facet: '$[0].facet',
            includeDrafts: '$[0].includeDrafts',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countEventsByStatusRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countEventsByStatusResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV3Event.countEventsByStatus(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of up to 100 events that belong to the same event category.
 * @param categoryId - Category ID.
 * @internal
 * @requiredField categoryId
 * @param options - Optional fields.
 */
export function listEventsByCategory(categoryId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            categoryId: '$[0]',
            paging: '$[1].paging',
            fields: '$[1].fields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listEventsByCategoryRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listEventsByCategoryResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['Array#events']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([categoryId, options]);
        const reqOpts = ambassadorWixEventsV3Event.listEventsByCategory(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'categoryId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an event by ID.
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @param options - Optional fields.
 * @returns Event.
 */
export function getEvent(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            fields: '$[1].fields',
            resolveFullAddress: '$[1].resolveFullAddress',
        };
        const responseTransformation = '$.event';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getEventResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV3Event.getEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an event by the `slug` URL.
 *
 *
 * The slug is the end of an event URL that refers to a specific event. For example, if an events' URL is `https://example.com/events/event/{my-event-slug}`, the slug is `my-event-slug`.
 * @param slug - URL slug.
 * @public
 * @requiredField slug
 * @param options - Optional fields.
 */
export function getEventBySlug(slug, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            slug: '$[0]',
            fields: '$[1].fields',
            resolveFullAddress: '$[1].resolveFullAddress',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getEventBySlugRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getEventBySlugResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([slug, options]);
        const reqOpts = ambassadorWixEventsV3Event.getEventBySlug(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'slug',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Finds an event by ID or URL slug.
 *
 *
 * Unlike the [`getEvent`](https://www.wix.com/velo/reference/wix-events-v2/wixeventsv2/getevent) function, which returns a "not found" error, `findEvent()` returns an empty response when an event is not found.
 * @internal
 * @param options - Optional fields.
 */
export function findEvent(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            slug: '$[0].slug',
            fields: '$[0].fields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _findEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _findEventResponse,
            depSchemas: { _agendaSettings, _location, _v3Event },
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV3Event.findEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-v3-event.universal.js.map